import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {FloatData} from "./float.data";

@Injectable()
export class CashManagementEntityModel extends EntityModel<FloatData> {
    constructor(injector: Injector) {
        super(injector, FloatData);
    }

    override isEntityCloneable(): boolean {
        return false;
    }
}
